import './full-page-slider.component.scss';

import {} from 'jquery';
import { TinySliderInstance, tns } from 'tiny-slider';

export class FullPageSliderComponent {
	static MAIN_CLASS = 'full-page-slider';

	/*
	 * STATIC STUFF
	 */

	static compileAll() {
		const jqElements = jQuery('.' + FullPageSliderComponent.MAIN_CLASS);

		jqElements.each((index, ithElement) => {
			const ithJqElement = jQuery(ithElement);
			new FullPageSliderComponent(ithJqElement);
		});
	}

	/**
	 * INSTANCE STUFF
	 */

	private slider!: TinySliderInstance;

	constructor(private readonly jqElement: JQuery) {
		this.initSlider();

		this.bindOverlayInteractions();
		this.bindVideoEvents();
		this.bindSliderEvents();

		// Autoplay video in first visible slide, if present
		this.playVideoInActiveSlide();
	}

	private initSlider() {
		const container = this.jqElement.find('.inner');

		this.slider = tns({
			container: container[0],

			items: 1,
			loop: true,
			slideBy: 'page',

			autoWidth: true,

			autoplay: false,

			mouseDrag: true,
			touch: true,

			//Show only dots
			nav: true,
			controls: false,
		});
	}

	private bindOverlayInteractions() {
		this.jqElement.find('.slide.video .overlay').click((ev) => {
			const overlay = jQuery(ev.currentTarget);
			const video = overlay.siblings('video').get(0) as
				| HTMLVideoElement
				| undefined;

			if (video) {
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			}
		});
	}

	private bindVideoEvents() {
		this.jqElement.find('.video-slide video').each((_, videoElement) => {
			const video = videoElement as HTMLVideoElement;
			const overlay = jQuery(video).siblings('.video-overlay');
			const playIcon = overlay.find('.play-icon');

			if (!playIcon.length) return;

			const updateIcon = () => {
				if (video.paused) {
					playIcon.text('▶️');
				} else {
					playIcon.text('⏸️');
				}
			};

			// Do first update manually
			updateIcon();

			// Update icon accordin to video play status
			video.addEventListener('play', updateIcon);
			video.addEventListener('pause', updateIcon);
			video.addEventListener('ended', updateIcon);
		});
	}

	private bindSliderEvents() {
		this.slider.events.on('indexChanged', (info) => {
			const slides = this.jqElement.find('.slide');

			// Get real DOM elements of previous and current slides
			const prevSlide = info.slideItems[info.indexCached] as HTMLElement;
			const currentSlide = info.slideItems[info.index] as HTMLElement;

			// Pause video in previous slide, if playing
			const prevVideo = prevSlide.querySelector(
				'video'
			) as HTMLVideoElement | null;
			if (prevVideo && !prevVideo.paused) {
				prevVideo.pause();
			}

			// Play video in current slide, if paused
			const currentVideo = currentSlide.querySelector(
				'video'
			) as HTMLVideoElement | null;
			if (currentVideo && currentVideo.paused) {
				currentVideo.play();
			}
		});
	}

	private playVideoInActiveSlide() {
		// Delay to ensure slider is initialized and DOM is ready
		setTimeout(() => {
			const slideItems = this.slider.getInfo().slideItems;
			const currentIndex = this.slider.getInfo().index;

			const activeSlide = slideItems[currentIndex] as HTMLElement;
			const video = activeSlide.querySelector(
				'video'
			) as HTMLVideoElement | null;

			if (video && video.paused) {
				video.play();
			}
		}, 0);
	}
}
